export const TIPI_PRATICA = [
  { value: "CILA", label: "CILA" },
  { value: "SCIA", label: "SCIA" },
  { value: "PERMESSO_COSTRUIRE", label: "Permesso di Costruire" },
  { value: "CATASTO", label: "Pratica Catastale" },
  { value: "LEGGE10", label: "Legge 10" },
  { value: "APE", label: "APE" },
  { value: "ALTRO", label: "Altro" },
];

export const STATI_PRATICA = [
  { value: "in_corso", label: "In corso" },
  { value: "in_attesa", label: "In attesa approvazione" },
  { value: "inoltrata_sue", label: "Inoltrata SUE" },
  { value: "sospesa", label: "Sospesa" },
  { value: "conclusa", label: "Conclusa" },
];

export const STATO_STYLES = {
  in_corso: "bg-blue-100 text-blue-800 border-blue-200",
  in_attesa: "bg-amber-100 text-amber-800 border-amber-200",
  inoltrata_sue: "bg-indigo-100 text-indigo-800 border-indigo-200",
  sospesa: "bg-red-100 text-red-800 border-red-200",
  conclusa: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const tipoLabel = (v, options = TIPI_PRATICA) => options?.find((t) => t.value === v)?.label || TIPI_PRATICA.find((t) => t.value === v)?.label || v;
export const statoLabel = (v) => STATI_PRATICA.find((s) => s.value === v)?.label || v;

export const formatDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};
